import { render, staticRenderFns } from "./LogoSupplierCard.vue?vue&type=template&id=bcebeb64&scoped=true&lang=pug&"
import script from "./LogoSupplierCard.vue?vue&type=script&lang=ts&"
export * from "./LogoSupplierCard.vue?vue&type=script&lang=ts&"
import style0 from "./LogoSupplierCard.vue?vue&type=style&index=0&id=bcebeb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcebeb64",
  null
  
)

export default component.exports